import React from 'react'
import { 
  Database, 
  Brain
} from 'lucide-react'
import { VehicleConfigurationCard } from '../../components/settings/VehicleConfigurationCard'
import { BusinessSettingsCard } from '../../components/settings/BusinessSettingsCard'
import { ConfigurationData } from '../../services/api'

interface ConfigurationSettingsProps {
  configData: ConfigurationData;
  updateField: (path: string, value: any) => void;
}

const ConfigurationSettings: React.FC<ConfigurationSettingsProps> = ({ configData, updateField }) => {
  
  const handleVehicleTypeChange = (vehicleType: string) => {
    updateField('job_settings.vehicle_type_for_job', vehicleType)
    updateField('job_settings.calc_freight_veiculo_job', vehicleType)
  }

  const handleBusinessSettingsChange = (field: string, value: number) => {
    updateField(`business_settings.${field}`, value)
  }

  return (
    <div className="space-y-6">
      {/* Card de Configuração de Veículos */}
      <VehicleConfigurationCard
        selectedVehicleType={configData.job_settings?.vehicle_type_for_job || ""}
        onVehicleTypeChange={handleVehicleTypeChange}
      />

      {/* Card de Configurações de Negócio */}
      <BusinessSettingsCard
        businessSettings={configData.business_settings || {
          sacos_por_palete: 0,
          peso_por_saco: 0,
          km_max_route: 0,
          media_sacos_por_order: 0
        }}
        onBusinessSettingsChange={handleBusinessSettingsChange}
      />

      {/* Campo Principal - Limite de Consultas IA */}
      <div 
        className="rounded-xl shadow-lg border p-6"
        style={{
          backgroundColor: 'var(--bg-card)',
          borderColor: 'var(--border-primary)'
        }}
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Brain className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h2
              className="text-xl font-semibold"
              style={{ color: 'var(--text-primary)' }}
            >
              Limite de Consultas para IA
            </h2>
            <p
              className="text-sm"
              style={{ color: 'var(--text-secondary)' }}
            >
              Configure quantos registros serão consultados para análise de IA
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label
              className="block text-sm font-medium mb-2"
              style={{ color: 'var(--text-primary)' }}
            >
              Máximo de Registros para Análise IA
            </label>
            <div className="relative">
              <Database
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
                style={{ color: 'var(--text-tertiary)' }}
              />
              <input
                type="number"
                value={configData.ai_query_limit || ""}
                onChange={(e) => updateField('ai_query_limit', parseInt(e.target.value) || 0)}
                className="w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                style={{
                  backgroundColor: 'var(--bg-card)',
                  borderColor: 'var(--border-primary)',
                  color: 'var(--text-primary)'
                }}
                min="1000"
                max="10000000"
                step="1000"
              />
            </div>
            <p
              className="text-sm mt-2"
              style={{ color: 'var(--text-secondary)' }}
            >
              💡 <strong>Recomendação:</strong> 1.000.000 registros para análises completas.
              Valores menores podem acelerar o processamento mas reduzir a precisão da IA.
            </p>
            <div
              className="mt-3 flex items-center gap-2 text-sm"
              style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
            >
              <span
                className="px-2 py-1 rounded"
                style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
              >
                Mínimo: 1.000
              </span>
              <span
                className="px-2 py-1 rounded"
                style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
              >
                Recomendado: 1.000.000
              </span>
              <span
                className="px-2 py-1 rounded"
                style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
              >
                Máximo: 10.000.000
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfigurationSettings